module.exports = __webpack_public_path__ + "static/media/DSCF31711.36295275.png";